module.exports = __webpack_public_path__ + "img/logo-ficha-guest.9bb64d00.png";